import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { CURRENT_CAR_ANNOUNCEMENT_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useCurrentCarAnnouncementSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'
import { BID_TYPES } from '@autobid/ui/constants/BID_TYPES'

export function useCurrentCarAnnouncementUserBid() {
  const { startListen } = useWebSocketStore()
  const { updateAnnouncementCarData } = useUpdateCar()

  const userBid = () => {
    startListen({
      eventName: 'premium.USER_BID',
      callbackName: CURRENT_CAR_ANNOUNCEMENT_SOCKET_CALLBACK,
      callback: (event) => {
        const { auctionId } = event.context

        updateAnnouncementCarData(auctionId, (item) => {
          const {
            price: amount,
            userId: user_id,
            nickname: user_nickname,
            status,
            carId,
            agentBid,
          } = event.context

          if (!item) {
            return item
          }

          if (item.id !== carId) {
            return item
          }

          return {
            ...item,
            bids: [
              {
                user_id,
                user_nickname,
                amount,
                type: BID_TYPES.USER_BID,
                timestamp: new Date(event.time * 1000).toISOString(),
                status,
                agent_bid: agentBid,
              },
              ...item.bids,
            ],
          }
        })
      },
    })
  }

  return { userBid }
}
